import React from 'react';
import { FaTag, FaUsers, FaCalendar, FaEye, FaEdit, FaTrash, FaPause, FaPlay } from 'react-icons/fa';
import ofertasService from '../../helpers/ofertasService';

const OfertaCard = ({ oferta, onView, onEdit, onDelete, onToggleStatus }) => {
    // Usar el servicio para obtener iconos, colores y formateo
    const getTipoIcon = (tipo) => {
        return <FaTag className={ofertasService.getTipoIcon(tipo)} />;
    };

    const getTipoText = (tipo) => {
        const tipos = ofertasService.getTiposOferta();
        const tipoEncontrado = tipos.find(t => t.value === tipo);
        return tipoEncontrado ? tipoEncontrado.label : tipo;
    };

    const getEstadoColor = (estado) => {
        return ofertasService.getEstadoColor(estado);
    };

    const getObjetivoColor = (objetivo) => {
        switch (objetivo) {
            case 'AUMENTAR_VENTAS':
                return 'bg-green-50 text-green-700';
            case 'CAPTAR_NUEVOS_CLIENTES':
                return 'bg-blue-50 text-blue-700';
            case 'FIDELIZAR_CLIENTES':
                return 'bg-purple-50 text-purple-700';
            default:
                return 'bg-gray-50 text-gray-700';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('es-ES');
    };

    const formatValue = (oferta) => {
        return ofertasService.formatOfertaValue(oferta);
    };

    return (
        <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
            <div className="p-6">
                {/* Header */}
                <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center">
                        {getTipoIcon(oferta.tipo)}
                        <div className="ml-3">
                            <h3 className="text-lg font-semibold text-gray-800 truncate">
                                {oferta.nombre}
                            </h3>
                            <p className="text-sm text-gray-600">
                                {getTipoText(oferta.tipo)}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center space-x-2">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getEstadoColor(oferta.estado)}`}>
                            {oferta.estado}
                        </span>
                    </div>
                </div>

                {/* Descripción */}
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {oferta.descripcion}
                </p>

                {/* Valor de la oferta */}
                <div className="bg-gray-50 p-3 rounded-lg mb-4">
                    <div className="text-center">
                        <span className="text-2xl font-bold text-gray-800">
                            {formatValue(oferta)}
                        </span>
                    </div>
                </div>

                {/* Información adicional */}
                <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                    <div className="flex items-center text-gray-600">
                        <FaCalendar className="mr-2" />
                        <span>{formatDate(oferta.fechaInicio)}</span>
                    </div>
                    <div className="flex items-center text-gray-600">
                        <FaUsers className="mr-2" />
                        <span>{oferta.usos || 0} usos</span>
                    </div>
                </div>

                {/* Objetivo */}
                <div className="mb-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getObjetivoColor(oferta.objetivoPrincipal)}`}>
                        {oferta.objetivoPrincipal?.replace(/_/g, ' ')}
                    </span>
                </div>

                {/* Métricas rápidas */}
                <div className="grid grid-cols-3 gap-2 mb-4 text-xs">
                    <div className="text-center">
                        <div className="font-semibold text-gray-800">{oferta.visualizaciones || 0}</div>
                        <div className="text-gray-500">Visualizaciones</div>
                    </div>
                    <div className="text-center">
                        <div className="font-semibold text-green-600">{oferta.usos || 0}</div>
                        <div className="text-gray-500">Usos</div>
                    </div>
                    <div className="text-center">
                        <div className="font-semibold text-blue-600">
                            {oferta.visualizaciones > 0 ? ((oferta.usos / oferta.visualizaciones) * 100).toFixed(1) : 0}%
                        </div>
                        <div className="text-gray-500">Conversión</div>
                    </div>
                </div>

                {/* Acciones */}
                <div className="flex justify-between items-center pt-4 border-t border-gray-200">
                    <div className="flex space-x-2">
                        <button
                            onClick={() => onView(oferta)}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                            title="Ver detalles"
                        >
                            <FaEye size={16} />
                        </button>
                        <button
                            onClick={() => onEdit(oferta)}
                            className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                            title="Editar"
                        >
                            <FaEdit size={16} />
                        </button>
                        {oferta.estado === 'ACTIVA' ? (
                            <button
                                onClick={() => onToggleStatus(oferta, 'PAUSADA')}
                                className="p-2 text-orange-600 hover:bg-orange-50 rounded-lg transition-colors"
                                title="Pausar"
                            >
                                <FaPause size={16} />
                            </button>
                        ) : (
                            <button
                                onClick={() => onToggleStatus(oferta, 'ACTIVA')}
                                className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                                title="Activar"
                            >
                                <FaPlay size={16} />
                            </button>
                        )}
                    </div>
                    <button
                        onClick={() => onDelete(oferta)}
                        className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        title="Eliminar"
                    >
                        <FaTrash size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OfertaCard; 